import React from "react";
import { Box, Typography, Divider } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { provider } from "lib/constants/disbursementProvider";
import TngDisbursementSettingPanel from "../components/panel/tngDisbursementSettingPanel";
import LoadingComponent from "components/loading";
import { getLang } from "app/feature/constants";

const useStyles = makeStyles((theme) => ({
  container: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2, 3, 2, 3),
    borderRadius: "8px",
  },
}));

function ConsumerEngagementReportComponents({
  lang,
  disbursementInfos,
  isFetching,
}) {
  const classes = useStyles();

  if (isFetching) {
    return (
      <Box
        className={classes.container}
        style={{ paddingTop: 40, paddingBottom: 40 }}
      >
        <LoadingComponent />
      </Box>
    );
  }

  return (
    <Box>
      <Box>
        <Box
          mb={1}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Box display="flex" alignItems="flex-end" fontWeight="bold">
            <Typography variant="h6" color="primary">
              {getLang(lang, "label.CONSUMER_ENGAGEMENT")}
            </Typography>
          </Box>
        </Box>
        <Divider />
      </Box>
      <Box mt={2}>
        {disbursementInfos.map((info, index) =>
          info.identifier === provider.touchNgo ? (
            <TngDisbursementSettingPanel disbursementInfo={info} key={index} />
          ) : null
        )}
      </Box>
    </Box>
  );
}

export default ConsumerEngagementReportComponents;
